module.exports = __webpack_public_path__ + "1ec5dd221ec1c8252433aa5a284c504e.png";